


import { AnimatePresence, motion } from "framer-motion";
import useMeasure from "react-use-measure";
import { Alert, Button } from "react-bootstrap";
import React, { useEffect } from "react";

import { Modal, MuniSpinner2 } from "../../../../components";
import { useGeneralAppStore } from "../../../../store/generalAppStore";
import { useActasStore } from "../../../../store/actasStore";
import { useActas } from "../../../../hooks/useActas";
import { useActaDetalleStore } from "../../../../store/actaDetalleStore";
import LocalShippingIcon from '@mui/icons-material/LocalShipping';


const ModalAsignarActasMaria = ({ actasSinEntregar, setActasSinEntregar, actasAsignar, setActasAsignar, setRefetch }) => {

    //? ESTADOS GLOBALES
    const { loads, modals, handlerModal } = useGeneralAppStore();
    const { setActaDetalle } = useActasStore();
    const { acta } = useActaDetalleStore();
    const { imprimirActas, asignarActasANotificador } = useActas();
    // const { actaDetalle } = useActaDetalleStore()

    const [ref, bounds] = useMeasure();

    useEffect(() => {
        return () => {
            handlerModal({ modal: false, modalName: "modal_asignar_actas_maria" })
        }
    }
        , [])

    return (
        <>
            <Modal
                backdrop={true}
                show={modals.includes('modal_asignar_actas_maria')}
                size={"md"}
                onHide={() => handlerModal({ modal: false, modalName: "modal_asignar_actas_maria" })}
                title={() => "Asignar Actas a SEND"}
            >
                <div className="position-relative">

                    {
                        loads.includes('asignar_notificador') &&
                        <div className="position-absolute h-100 w-100 z-3 d-flex justify-content-center align-items-center" style={{ backgroundColor: "rgba(255,255,255,0.7)" }}>
                            <MuniSpinner2 />
                        </div>
                    }
                    <Alert variant="warning" className="d-flex flex-column gap-2 align-items-center">
                        <div className="bg-white d-flex flex-column align-items-center gap-1 p-2 py-4 border rounded shadow-lg w-100">
                            Actas que seran asignadas a MARIA CASTILLO
                        </div>
                    </Alert>

                    <div className="d-flex gap-2 flex-wrap justify-content-center my-4">
                        {
                            [...actasAsignar, ...actasSinEntregar]?.map((acta) => {
                                return (
                                    <div key={acta?.id}
                                        className={`${acta?.estado_id == 2 ? 'bg-primary text-white' : 'bg-warning'} px-2 rounded pt-1  fw-bold `}
                                        style={{ width: "fit-content" }}
                                    >
                                        <p className="m-0">Acta - {acta?.numero_acta}</p>
                                    </div>
                                )
                            })
                        }
                    </div>
                    <hr />
                    <section className="w-100 d-flex justify-content-end gap-2">
                        <Button size="md" variant="warning"
                            onClick={() => {
                                asignarActasANotificador({
                                    actas: [...actasAsignar, ...actasSinEntregar].map((acta) => acta.id),
                                    user_id_asignado: 86065,
                                    acta_detalle: acta?.id
                                    // user_id_asignado: 165406
                                },
                                    setActasAsignar,
                                    setActasSinEntregar,
                                    setRefetch)
                            }}><LocalShippingIcon /> Asignar</Button>
                        <Button size="md" variant="danger" onClick={() => handlerModal({ modal: false, modalName: "modal_asignar_actas_maria" })}>Cancelar</Button>
                    </section>
                    <AnimatePresence>
                        <motion.div animate={{ height: bounds.height }} className="overflow-hidden">
                            estas seguro?
                        </motion.div>
                    </AnimatePresence>
                </div>



            </Modal>
        </>
    );
}
export default ModalAsignarActasMaria;